import React from 'react'


const Minor = () => {
  return (
    <div>
    <div className='myheader'>
        <button className='merabtn'>
          <span>Minor Projects</span><i></i>
      </button>
        </div>
        
<table className="table-fill">
    <thead>
        <tr>
            <th className="text-left">Sr.No</th>
            <th className="text-left">Project Title</th>
            <th className="text-left">Made By</th>
            <th className="text-left">Demonstration</th>
        </tr>
    </thead>

    <tbody className="table-hover">
            <tr>
                <td className="text-left">1</td>
                <td className="text-left">Solid Waste Management</td>
                <td className="text-left">19BEC081 and 19BEC131</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://youtu.be/DM7TUYvuAso">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">2</td>
                <td className="text-left">Gesture Based Computer Control System</td>
                <td className="text-left">19BEC008 and 19BEC024</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://www.youtube.com/watch?v=6VrkQFkU940">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">3</td>
                <td className="text-left">Single Point Positioning and Study of Kalman Filter for NavIC Receiver</td>
                <td className="text-left">19BEC046 and 19BEC052</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://www.youtube.com/watch?v=DW_0k2FcVZE">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">4</td>
                <td className="text-left">Weight Based Sorting Machine</td>
                <td className="text-left">18BEC080 and 18BEC117</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://www.youtube.com/watch?v=XVMmHWit07s">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">5</td>
                <td className="text-left">Smart Door system to prevent Covid 19</td>
                <td className="text-left">18BEC037 and 18BEC069</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://youtu.be/daqhiLJKUZc">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">6</td>
                <td className="text-left">Embeeded Eco System using RISC-V Processor</td>
                <td className="text-left">18BEC067 and 18BEC083 and 18BEC122</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://www.youtube.com/watch?v=7Bqtp5F429s">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">7</td>
                <td className="text-left">IOT Based Patient Health Monitoring System</td>
                <td className="text-left">17BEC070 and 18BEC151</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://www.youtube.com/watch?v=7Bqtp5F429s">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">8</td>
                <td className="text-left">Augmented reality Based Jewelry try-on using Machine Learning</td>
                <td className="text-left">17BEC124</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://www.youtube.com/watch?v=CmWeypKjvR4">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">9</td>
                <td className="text-left">Software Design of OCR for Ids and Image Segmenatation</td>
                <td className="text-left">17BEC118</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://www.youtube.com/watch?v=8z00qNaRjLs">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">10</td>
                <td className="text-left">Solar Tracker system with IOT</td>
                <td className="text-left">17BEC078 and 17BEC097</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://youtu.be/LlHVKYTXa4E">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">11</td>
                <td className="text-left">Wide band Spectrum Analysis and Blind DeModulation</td>
                <td className="text-left">17BEC076</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://youtu.be/C5jwVKEfcNI">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">12</td>
                <td className="text-left">AI Based Model</td>
                <td className="text-left">17BEC038</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://youtu.be/QZvO_uPKSt4">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">13</td>
                <td className="text-left">Weed Detection using Deep Learning</td>
                <td className="text-left">17BEC018</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://youtu.be/Smanas5vncQ">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">14</td>
                <td className="text-left">Distributed Data Acquisition System</td>
                <td className="text-left">16BEC058</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://youtu.be/gesobqy9iCo">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">15</td>
                <td className="text-left">Smart water Management</td>
                <td className="text-left">15MECE09</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://youtu.be/MkkVh-DujZg">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">16</td>
                <td className="text-left">Emergency Rescue System for Road Accident</td>
                <td className="text-left">17BEC017 and 17BEC013</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://youtu.be/fc4Ia5IFYuU">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">17</td>
                <td className="text-left">Smart Assistant Helmet</td>
                <td className="text-left">17BEC103</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://youtu.be/WhWKlxaK9ew">Click Here</a> </td>
            </tr>
            <tr>
                <td className="text-left">18</td>
                <td className="text-left">Smart Dustbin</td>
                <td className="text-left">17BEC069 and 17BEC076</td>
                <td className="text-center"> <a className="mylnk" target='_blank' href="https://youtu.be/Csfl3gZeqK8">Click Here</a> </td>
            </tr>
        
    </tbody>
</table>

    
    </div>
  )
}

export default Minor